const destroyFns = [];
export default destroyFns;


//////////////////
// WEBPACK FOOTER
// ./node_modules/antd/es/modal/destroyFns.js
// module id = 1241
// module chunks = 0